import type { Plan } from 'js/src/client';

export enum UPGRADE_STATUS {
    SUCCESS = 'success',
    CARD_DECLINED = 'card_declined',
    TEAM_SIZE_ERROR = 'team_size_error',
    PERMISSION_ERROR = 'permission_error',
    SCA_REQUIRED = 'sca_required',
    GENERIC_ERROR = 'generic_error',
}

export type PlanSwitchErrorInfo = {
    targetPlan: Plan;
    feature: string;
};

export type ConfirmationModalData = {
    plan: Plan;
    email: string;
};

export type RetryUpgradeInfo = {
    plan: Plan;
};

export const ANALYTICS_QS = {
    KEY: 'opp', // old plan price
    DONE: 'done', // done recording analytics
};

// When the pricing page is opened with `?auto_upgrade=<plan_name>`, it automatically
// triggers a switch to that plan on load. Used by in-app upsells so paid users land on the
// full pricing page (with its richer error handling) instead of the inline switch flow.
export const AUTO_UPGRADE_QS = {
    KEY: 'auto_upgrade',
};
